import { collection, query, getDocs, QueryDocumentSnapshot, DocumentData, setDoc, doc } from 'firebase/firestore';
import { db } from '../../../config/firebase';
import DbCollections from '../../../resources/enums/DbCollections';
import { Reward } from '../types';

const mapSnapshotToReward = (doc: QueryDocumentSnapshot<DocumentData>) => {
    return {
        ...doc.data(),
        id: doc.id,
    } as Reward;
};

export const getRewardsFirebase = async () => {
    const querySnapshot = await getDocs(query(collection(db, DbCollections.Rewards)));
    const rewards = [] as Reward[];
    querySnapshot.forEach(async (doc) => {
        rewards.push(mapSnapshotToReward(doc));
    });
    return rewards;
};

export const saveRewardFirebase = async (reward: Reward) => {
    await setDoc(doc(db, DbCollections.Rewards, reward.id), reward);
    return reward;
};
